// extracted by mini-css-extract-plugin
module.exports = {"pinkSlogan":"style_pinkSlogan__cYqF_","content":"style_content__goFRr","slogan":"style_slogan__ea45p","link":"style_link__1u1gl"};